var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.316 5.684H5.684v12.632h12.632V5.684z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.316 24L24 18.316h-5.684V24z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.684h-5.684v12.632H24V5.684z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.316 18.316H5.684V24h12.632v-5.684z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.316v3.79C0 23.151.848 24 1.895 24h3.79v-5.684H0z",
    fill: "#188038"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.684v-3.79A1.894 1.894 0 0022.105 0h-3.79v5.684H24z",
    fill: "#1967D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.316 0H1.895A1.894 1.894 0 000 1.895v16.42h5.684V5.686h12.632V0z",
    fill: "#4285F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.275 15.483c-.472-.319-.799-.785-.977-1.4l1.096-.452c.1.379.273.673.52.881.247.208.547.311.898.311.358 0 .666-.109.923-.327.258-.218.387-.495.387-.832 0-.344-.136-.625-.407-.843-.272-.218-.613-.327-1.02-.327h-.633V11.41h.568c.35 0 .646-.094.886-.284.24-.19.36-.448.36-.778a.86.86 0 00-.322-.703c-.215-.175-.487-.263-.817-.263-.322 0-.578.085-.767.257a1.51 1.51 0 00-.414.633L7.472 9.82c.143-.407.407-.767.794-1.078.387-.311.88-.467 1.48-.467a2.7 2.7 0 011.198.257c.353.172.631.41.832.714.2.304.3.646.3 1.025 0 .386-.093.713-.28.982a1.925 1.925 0 01-.687.617v.065c.351.144.656.382.882.687.228.307.344.675.344 1.105 0 .43-.11.813-.327 1.15-.218.336-.52.6-.902.793a2.836 2.836 0 01-1.293.291 2.677 2.677 0 01-1.538-.477zm6.731-5.438l-1.203.87-.602-.912 2.159-1.557h.827v7.344h-1.18v-5.745z",
    fill: "#4285F4"
  })));
}
export default SvgGcalIcon;